module.exports = __webpack_public_path__ + "static/media/exactclubicon.67dcd4d4.svg";